/** Short dollar format: $1.2B, $401K, $3,200 */
export function formatDollarsShort(value: number): string {
  if (value >= 1_000_000_000) return `$${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${Math.round(value / 1_000)}K`;
  return `$${Math.round(value).toLocaleString()}`;
}

/** Full dollar format: $1,402,209 */
export function formatDollarsFull(value: number): string {
  return `$${Math.round(value).toLocaleString()}`;
}

/** Simple English pluralization */
export function pluralize(count: number, singular: string, plural?: string): string {
  return count === 1 ? singular : (plural ?? `${singular}s`);
}
